export default {
  on: 'on',
  off: 'off',
};
